import { Component, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldWrapper } from '@ngx-formly/core';
import { FormGroup } from '@angular/forms';
import { IonicSlides } from '@ionic/angular';
import { AppService } from '../app.service';
import { VpcHazService } from '../pages/vpc-haz/vpc-haz.service';

@Component({
  selector: 'haz-type-select',
  styles: [
    `
      .hazcard {
        border-radius: 7px;
        margin: 10px 15px !important;
        padding: 10px;
        display: block;
        position: relative;
      }
      .hazimg_row {
        margin: 10px;
      }
      .ionslide {
        border-radius: 10px;
      }
      swiper-container {
        --swiper-pagination-bullet-inactive-color: black;
        --swiper-pagination-color: white;
      }
      ion-card {
        border-radius: 12px;
        margin-bottom: 0;
        box-shadow: 0px 3px 6px #00000029;
      }
      .img-slide.slides {
        height: 180px;
        width: 100%;
        display: block;
        position: relative;
        border-radius: 10px;
      }
      .left-arrow {
        position: absolute;
        top: 50%;
        left: 16px;
        font-size: 25px;
        z-index: 2;
      }

      .right-arrow {
        position: absolute;
        top: 50%;
        right: 16px;
        font-size: 25px;
        z-index: 2;
      }

      .slide-image {
        max-width: 100vw !important;
        max-height: 250px !important;
      }

      .assign_tags {
        color: #000000;
        font-size: 16px;
        font-weight: bold;
        margin-left: 10px;
      }
      .haz_housekeeping {
        font-size: 12px;
        font-weight: bold;
      }
      .house_col_div {
        margin-left: 10px;
        color: red;
      }
      .checkbox_hazid {
        padding: 2px;
        background-color: #6a6a6a;
        color: white;
        border-top-right-radius: 100px;
        border-bottom-right-radius: 100px;
        width: 129px;
        height: 31px;
        border-bottom-left-radius: 100px;
        border-top-left-radius: 100px;
      }
      .upload_animation_container {
        background: #edf5f5;
      }
      .anim_text {
        position: absolute;
        margin-top: 150px;
        text-align: center;
        width: 100%;
        color: #007382;
        font-size: 18px;
        font-weight: 600;
      }
    `,
  ],
  template: ` <ion-card class="hazcard ion-no-margin">
    <ion-row class="assign_tags">
      <ion-col>
        <ion-label>{{ to.label }}</ion-label>
      </ion-col>
    </ion-row>
    <ion-row class="assign_tags">
      <ion-col style="margin-top: -10px;">
        <ng-container class="house_col_div" #fieldComponent></ng-container>
      </ion-col>
    </ion-row>
  </ion-card>`,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HazidTypeFormlyType extends FieldWrapper {
  hazSelectedImages: any[] = [];
  imageUploading: boolean = false;
  swiperModules = [IonicSlides];

  constructor(
    private appService: AppService,
    private hazService: VpcHazService
  ) {
    super();
  }
  slidePrev() {}
  slideNext() {
    console.log('prev slides');
  }
  export() {}
  ngOnInit() {
    this.hazSelectedImages = this.appService.hazImageData;

    this.hazService.imageUploadingObservable.subscribe((res) => {
      this.imageUploading = res;
    });
  }

  expandItem() {
    this.to.expanded = !this.to.expanded;
  }
}
